var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueMissingDisplayModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.46.045-.01.01L20.542 19.15l-1.404 1.404-2.671-2.67h-.174v2.646h-2v-2.647H5.706v2.647h-2v-2.647H1V11.53h3.235V5.65L0 1.415 1.414 0l.045.045ZM5.18 1l2 2h6.585v6.585L19 14.821v-3.292h-3.235V1H5.179Zm1.055 10.53V7.65l3.88 3.88h-3.88ZM3 13.53h9.115l2.353 2.352H3V13.53Z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueMissingDisplayModel);
export default __webpack_public_path__ + "static/media/issue_missing_display_model.c95f4d5eaab2373006760d43d07ea9f9.svg";
export { ForwardRef as ReactComponent };